<template>
    <div class="w-768">
        <multi-lang-toggle :form="form"></multi-lang-toggle>

        <translatable #default="{ languages, selectedLanguage }" :errors="warningTabs" class="w-full">

            <div v-for="lang in languages" :key="lang">
                <simple-input
                    v-show="lang === selectedLanguage"
                    v-model="form.heading[lang]"
                    class="mb-16"
                    emojis
                >
                    {{ $t('form.title') }}
                    <span v-if="languages.length > 1">({{ lang }})</span>
                </simple-input>

                <wysiwyg
                    v-show="lang === selectedLanguage"
                    v-model="form.content[lang]"
                    full-featured
                >
                    {{ $t('form.content') }}
                    <span v-if="languages.length > 1">({{ lang }})</span>
                </wysiwyg>
            </div>

        </translatable>
    </div>
</template>

<script>
import Translatable from '../forms/Translatable.vue';
import {mapState} from 'pinia';
import {useMainStore} from '../../state/store';
import LanguagesMultiToggle from '../forms/LanguagesMultiToggle.vue';
import Wysiwyg from '../forms/Wysiwyg.vue';
import Input from '../forms/Input.vue';

export default {
    components: {
        'translatable': Translatable,
        'multi-lang-toggle': LanguagesMultiToggle,
        'wysiwyg': Wysiwyg,
        'simple-input': Input,
    },
    props: {
        form: {
            required: true,
        },
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany']),
        warningTabs() {
            let languages = this.currentCompany.jobsite.active_languages;
            let errorLang = [];

            for (let index in languages) {
                if (!this.form.data.heading[languages[index]] && this.form.data.published[languages[index]]) {
                    errorLang.push(languages[index]);
                }
            }
            return errorLang;
        },
    },
};
</script>
